import { listCommercialOperations } from '@/modules/commercial/services/commercialOperationsService';
import { BILLABLE_OPERATION_STATUSES } from '@/modules/commercial/types';
import { listInvoices } from '@/modules/billing/services/invoicesService';
import type { Invoice } from '@/modules/billing/types';

export type BillingDashboardStats = {
  issuedInvoices: number;
  pendingInvoices: number;
  estimatedRevenue: number;
  operationsPendingBilling: number;
};

function isIssuedRevenue(invoice: Invoice): boolean {
  return invoice.status === 'issued' && invoice.type === 'internal';
}

export async function fetchBillingDashboardStats(): Promise<BillingDashboardStats> {
  const [invoices, operations] = await Promise.all([
    listInvoices(),
    listCommercialOperations(),
  ]);

  const issued = invoices.filter((i) => i.status === 'issued');
  const pending = invoices.filter(
    (i) => i.status === 'pending' || i.status === 'draft',
  );

  const billableOps = operations.filter((o) =>
    BILLABLE_OPERATION_STATUSES.includes(o.status),
  );
  const invoicedOpIds = new Set(
    invoices
      .filter((i) => i.commercialOperationId && i.status !== 'cancelled')
      .map((i) => i.commercialOperationId as string),
  );
  const operationsPendingBilling = billableOps.filter(
    (o) => !invoicedOpIds.has(o.id),
  ).length;

  const estimatedRevenue = issued
    .filter(isIssuedRevenue)
    .reduce((sum, i) => sum + i.total, 0);

  return {
    issuedInvoices: issued.length,
    pendingInvoices: pending.length,
    estimatedRevenue,
    operationsPendingBilling,
  };
}
